export const USER_STATUS = {
  INCOMPLETE: "incomplete",
  ACTIVE: "active",
  INACTIVE: "inactive",
  BLOCKED: "blocked",
  RESET_USERNAME: "reset_username",
  DELETED: "deleted",
};

export const userStatusLabels = {
    [USER_STATUS.INCOMPLETE]: "Reg. Incomplete",
    [USER_STATUS.ACTIVE]: "Active",
    [USER_STATUS.INACTIVE]: "Vacation",
    [USER_STATUS.BLOCKED]: "Restricted",
    [USER_STATUS.RESET_USERNAME]: "Reset Username",
    [USER_STATUS.DELETED]: "Deleted",
};

export const userStatusBgColors = {
  [USER_STATUS.ACTIVE]: "linear-gradient(90deg, #19C38B, #088D96)",
  [USER_STATUS.BLOCKED]: "linear-gradient(90deg, #E7A000, #C96500)",
  [USER_STATUS.DELETED]: "linear-gradient(90deg, #797979, #595959)",
  [USER_STATUS.RESET_USERNAME]: "linear-gradient(90deg, #FFB0AA, #FF7676)",
  [USER_STATUS.INACTIVE]: "linear-gradient(90deg, #F178B6, #A549BC)",
  [USER_STATUS.INCOMPLETE]: "linear-gradient(90deg, #FF1111, #9B1C00)",
};
